
export default {
name: "",
props: {
  list: {
    type: Array,
    default: []
  },
  
},
methods: {
  selection(item, index) {
    if (index == 0) { return; }
    this.$emit('selection', item);
  },
  goToView(path) {
    this.$router.push({path : this.localePath(path)})
  }
}
}
